import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { BaseServiceService } from 'src/app/services/base-service.service';
import { SesionEnlace, SesionEnlaceService } from 'src/app/services/sesion-enlace.service';

/**
 * Entrada del enlace de formulario expuesto: .../redirect?k=<clave>.
 * La clave solo permite pedir y validar el OTP; tras validarlo se abre el formulario con una sesión corta.
 * Los enlaces del formato anterior (sin k) se muestran como vencidos.
 */
@Component({
  selector: 'app-form-redirect',
  templateUrl: './form-redirect.component.html'
})
export class FormRedirectComponent implements OnInit {
  clave: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private baseService: BaseServiceService,
    private sesionEnlace: SesionEnlaceService
  ) {}

  ngOnInit() {
    this.clave = this.route.snapshot.queryParamMap.get('k');
    if (this.clave) {
      this.sesionEnlace.guardarClave(this.clave);
    }
  }

  abrirFormulario(sesion: SesionEnlace) {
    this.authService.setAuthentication(true);
    this.baseService.setRedirectAccess(true);

    // Navegar primero y luego publicar los ids, para que el formulario se renderice una sola vez
    this.router.navigate(['home/formulario']).then(() => {
      setTimeout(() => {
        this.baseService.exportIdEjecucionProceso(String(sesion.IdEjecucionProceso));
        this.baseService.exportIdEjecucionTarea(String(sesion.IdEjecucionTarea));
        if (sesion.IdFormulario) {
          this.baseService.exportIDForm(String(sesion.IdFormulario));
        }
      }, 100);
    });
  }
}
